import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

const touchOptions = {
  enableMouseEvents: true,
  enableTouchEvents: true,
  ignoreContextMenu: true,
  delayTouchStart: 0,
  delayMouseStart: 0,
  touchSlop: 5,
};

function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia === 'function') {
    if (window.matchMedia('(pointer: coarse)').matches) return true;
  }
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function getDndBackend() {
  if (isTouchDevice()) {
    return { backend: TouchBackend, options: touchOptions };
  }

  return { backend: HTML5Backend };
}
